
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { DataType } from "@dndModels/Types";
import { 
  FeatureBase 
} from "@models";

/**
 * This is a type of Feature with a little more
 * dynamics to it.  
 * Think Feature that has Features.  
 * Like a FeatureBase, but an extra level.
 * 
 * Also it gets saved to its own collection,
 * and generally when it's used as a Feature 
 * the_feature will just contain the type.
 * CharacterFeature will let the user choose
 * the specific option they want based on the type.
 * 
 * Part of why it's going to its own collection
 * is that some of these can show up in different 
 * places (like class features and feats).
 * 
 * Eldritch Invocations and Pact Boons could
 * be shoehorned into this, but I think it's best
 * not to because of how Invocations often have
 * Boons as prereqs.
 * 
 * I am going to use this for Totem Attunements,
 * Maneuvers, and Metamagic.  
 * I'll probably find other uses as well.
 */

export class SpecialFeature extends DandDFeatureSource {
  data_type: DataType = "special_feature";
  feature_source_type = "SpecialFeature";
  type = "";
  repeatable = false;

  get special_feature_type() {
    return this.type;
  }

  constructor(obj?: any, is_new = false) {
    super(obj, "SpecialFeature");
    if (obj) {
      this.type = obj ? obj.type : "";
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature_base = new FeatureBase(o);
          this.feature_bases.push(feature_base);
        });
      }
      this.repeatable = obj.repeatable ? obj.repeatable : false;
    }
  }
  
  get_detail_format() {
    const str = `${super.get_detail_format()}; ${this.type}`;
    return str.trim();
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type = obj ? obj.type : "";
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature_base = new FeatureBase(o);
  //         this.feature_bases.push(feature_base);
  //       });
  //     }
  //     this.repeatable = obj.repeatable ? obj.repeatable : false;
  //   }
  // }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      type: this.type,
      repeatable: this.repeatable
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      type: this.type,
      repeatable: this.repeatable
    };
  }

  copy(copyMe: SpecialFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.type = copyMe.type;
    this.repeatable = copyMe.repeatable;
  }

  clone(drop_ids = false): SpecialFeature {
    const new_obj = new SpecialFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}